import { render, staticRenderFns } from "./DialogWorkspace.vue?vue&type=template&id=7f2327c5"
import script from "./DialogWorkspace.vue?vue&type=script&lang=js"
export * from "./DialogWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports